/**
 * Rental shops have kind === 0.
 * Mirrors water-on-web: packages/repository/src/models/shop.ts#isRentalShop
 */
export function isRentalShop(kind: number): boolean {
  return kind === 0;
}
